import {
  STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_BEGIN:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            pendingFileImage: true,
            errorSelectFileImage: null
          }
        }
      }

    case STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_SUCCESS:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            saveData: {
              ...state.takingCarManagement.fastStockLoading.saveData,
              files: action.data
            },
            pendingFileImage: false,
            errorSelectFileImage: null
          }
        }
      }

    case STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_FAILURE:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            pendingFileImage: false,
            errorSelectFileImage: "Error al seleccionar la imagen."
          }
        }
      }

    default:
      return state
  }
}
